import { Link } from "react-router-dom";
import UnderConstruction from "../components/UnderConstruction";
import styles from "../styles/about.module.css";

export default function About() {
  return (
    <div className={styles.aboutDiv}>
      <div className={styles.backButton}>
        <Link className={styles.backLink} to="/">
        &larr; Back to Home
        </Link>
      </div>
      <UnderConstruction />
      <div>
        <div idName={styles.intro}>
          {/* Introduction about who I am */}
          <h1>About Me</h1>
        </div>
        <p>
            My name is Emmanuel Muñoz, but I typically go by Emmet. I am a third year undergraduate studying Computer Science at the Georgia Institute of Technology! 
        </p>
        <p>
            Throughout my time at Georgia Tech, I balance various responsibilities ranging from academic and laboral. It hasn't been easy, but I have learned how to manage my time effectively and ensure that I meet all of my obligations while still maintaining my scholarship.
        </p>
        <p>
            Outside of campus, I am distribution manager at my family's business, EMCA Foods LLC, and have maintained this position since 2020. I am responsible for directly supervising and managing our employees ensuring that they properly deliver and merchandise in a timely and ordered manner.
        </p>
        <p>
            On campus, I am a proactive Teaching Assistant for CS 2340: Objects and Design under Dr. Feíjóo-García. The class is heavily project based as students are tasked with building projects under the supervision of a Teaching Assistant serving as both a mentor and a Product Manager. Over my 5 semesters, I have had the opportunity to mentor 100+ students guiding them through the AGILE process with Daily Standups, consistently providing feedback on their iterative development process, and ensuring that each team delivered an exceptional product by the last sprint. I was also responsible for resolving interpersonal conflicts as well as communicating course announcements in a timely manner. Whenever students encountered an issue during the course or needed assistance with debugging, I made sure that I was their number one resource and made myself available as much as I could.
        </p>
        <p>
            Year-round, I actively participate as an undergraduate researcher in PARCE Lab under supervision by Dr. Feíjóo-García. Our lab focuses on Human-Centered Interactions featuring multimodal agents as well as tackling culturally relevant issues in Computer Science higher education. 
During Summer 2025, I contributed to the qualitative analysis of a study on using AI agents as a teaching method for a class of over 300 students. I gained valuable experience in analyzing over 300 individual responses.
Throughout Fall 2025, I participated in the quantitative analysis of a study targeting student's experiences at internships. It was here where we discovered…
        </p>
        <p>
            I am also an active member in GT Peru, a student organization for Peruvian students on campus. I am the head of marketing, and I design and collaborate with the rest of the board members to properly execute club tasks on campus. 
        </p>
      </div>
    </div>
  );
}